import { create } from 'zustand';
import darkTheme from '../../../assets/themes/dark';
import lightTheme from '../../../assets/themes/light';

export const useThemeStore = create((set, get) => ({
  // État initial
  theme: lightTheme,

  // Actions
  setTheme: (themeName) => {
    const themes = [lightTheme, darkTheme];
    const theme = themes.find((theme) => theme.name === themeName);
    if (theme) {
      set({ theme });
    }
  },

  clearTheme: () => set({ theme: null }),

  getTheme: () => get().theme,

  isThemeLoaded: () => get().theme !== null,
}));
